if (!customElements.get('juo-sub-widget')) {
  customElements.define(
    'juo-sub-widget',
    class JuoSubWidget extends HTMLElement {
      constructor() {
        super();
        this.queryParam = this.dataset.queryParam || 'sub';
        this.inputs = this.querySelectorAll('input[name="selling_plan"]');
        
        // --- NOWOŚĆ DLA JUO ---
        // Znajdujemy wszystkie formularze koszyka na stronie
        this.cartForms = Array.from(document.querySelectorAll('form[action$="/cart/add"]'));
        this.initJuoInputs();
        // ----------------------
      }

      connectedCallback() {
        this.selectedSellingPlanId = null;
        this.popup = this.querySelector('.selling-plan__richtext');
        this.quantityInput = document.querySelector('input[name="quantity"]');
        this.allCards = this.querySelectorAll('.sub-wid__card');
        this.subscriptionProductCheckbox = this.querySelector('.sub-wid__subscription-product-checkbox');
        
        this.initialSelect();
        this.addEventListeners();

        // Logika etykiet: qty 1 → drugi plan (index 2), qty 2 → trzeci plan (index 3)
        this.enableLabels = this.dataset.enableLabels;
        if(this.enableLabels) {
          const applyRecommendationLabel = (quantityDataIndex) => {
            const cardIndexToShow = parseInt(quantityDataIndex, 10) + 1;
            this.allCards.forEach((card, index) => {
              const cardDescription = card.querySelector('.sub-wid__card-description');
              if(!cardDescription) return;
              if(index === cardIndexToShow) {
                cardDescription.classList.remove('hidden');
              } else {
                cardDescription.classList.add('hidden');
              }
            });
          };
          subscribe(PUB_SUB_EVENTS.quantityVariantChange, (event) => {
            const quantityDataIndex = event.data.quantityDataIndex;
            if(!quantityDataIndex) return;
            applyRecommendationLabel(quantityDataIndex);
          });
          // Stan początkowy: ustaw etykietę według aktualnie wybranej ilości
          const selectedQuantityInput = document.querySelector('input[name="quantity"]:checked');
          if(selectedQuantityInput?.dataset.quantityIndex) {
            applyRecommendationLabel(selectedQuantityInput.dataset.quantityIndex);
          }
        }
      }

      // --- NOWOŚĆ DLA JUO ---
      // Tworzy hidden inputy w każdym formularzu na stronie
      initJuoInputs() {
        this.cartForms.forEach(form => {
          if (!form.querySelector('input[name="selling_plan"]')) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            form.appendChild(input);
          }
        });
      }

      // Aktualizuje wartość we wszystkich formularzach
      updateJuoForms(planId) {
        this.cartForms.forEach(form => {
          const input = form.querySelector('input[name="selling_plan"]');
          if (input) {
            input.value = planId || '';
          }
        });
      }
      // ----------------------

      addEventListeners() {
        this.inputs?.forEach((input) => {
          input.addEventListener('change', (event) => {
            this.handleWidgetChange(event); 
            this.updateUrl(event.target.value);
          });
        });
      }
      
      handleWidgetChange(event) {
          this.selectedSellingPlanId = event.target.value;
          
          // --- AKTUALIZACJA JUO ---
          this.updateJuoForms(this.selectedSellingPlanId);
          // ------------------------

          const singlePaymentImage = document.querySelector('.payment-image-single-time-payment');
          const subscriptionPaymentImage = document.querySelector('.payment-image-subscription');
          
          if (event.target.value !== '') { 
            if(singlePaymentImage) singlePaymentImage.style.display = 'none';
            if(subscriptionPaymentImage) subscriptionPaymentImage.style.display = 'block';
            this.popup?.classList.remove('hidden');

            publish(PUB_SUB_EVENTS.addImageToGallerySlider, {
              blockId: this.dataset.blockId,
              imageUrl: this.dataset.sliderImage,
            });

            this.subscriptionProductCheckbox?.removeAttribute('disabled');
            this.subscriptionProductCheckbox?.setAttribute('checked', '');

          } else { 
            if(singlePaymentImage) singlePaymentImage.style.display = 'block';
            if(subscriptionPaymentImage) subscriptionPaymentImage.style.display = 'none';
            this.popup?.classList.add('hidden');
            
            this.subscriptionProductCheckbox?.setAttribute('disabled', '');
            this.subscriptionProductCheckbox?.removeAttribute('checked');
            
            publish(PUB_SUB_EVENTS.removeImageFromGallerySlider, {
              blockId: this.dataset.blockId,
              imageUrl: this.dataset.sliderImage,
            });
          }

          publish(PUB_SUB_EVENTS.sellingPlanChange, {
            data: {
              sellingPlanId: this.selectedSellingPlanId,
            },
          });
      }
      
      initialSelect() {
        const urlParams = new URLSearchParams(window.location.search);
        let urlValue = urlParams.get(this.queryParam);

        if (!urlValue) {
          urlValue = ''; 
        }

        const targetInput = Array.from(this.inputs).find(
          (input) => input.value === urlValue
        );

        if (targetInput) {
          targetInput.checked = true;
          this.handleWidgetChange({ target: targetInput });
        }
      }

      updateUrl(value) {
        const url = new URL(window.location.href);
        const defaultValue = '';

        if (value && value !== defaultValue) {
          url.searchParams.set(this.queryParam, value);
        } else {
          url.searchParams.delete(this.queryParam);
        }

        window.history.replaceState({}, '', url.toString());
      }
    }
  );
}